// main
import { useHistory } from "react-router-dom";

import WebbDividerMedium from "../webx/webb-divider-md"

import { Button } from "antd";

export default function MainIntroModule () {
  
  const history = useHistory();

  return (
  <>
    <div className='text-center'>
      <h1 className='m-0'>Creator Economy</h1>
      <h1 className='m-0'>NFT Marketplace</h1>

      <WebbDividerMedium />
      
      <h4 className='m-0 text-color-next text-bold'>Own Your Intellectual Property</h4>
    </div>

    <WebbDividerMedium />
    <WebbDividerMedium />

    <div className='text-center'>
      <Button 
        type="primary" 
        className='height-md back-color-main border-none rounded-wd px-3'
        onClick={() => history.push('/auth')}
      >Get Started</Button>
    </div>

  </>
  )
}